export default {
  WEBSITE: 'http://117.50.60.12',
  WEBSITEINTL: 'http://36.255.222.163',
  APIHOST: 'https://mobvoi-mw-test.weta365.com/cwhCopilot',
  AVATARURL: 'wss://streaming-neural-avatar-dev.mobvoi.com/websocket/avatar'
}
